import { render, staticRenderFns } from "./JobCompanyContact.vue?vue&type=template&id=5dd6ee1c&"
import script from "../../../services/admin/job/job-company-contact.js?vue&type=script&lang=js&"
export * from "../../../services/admin/job/job-company-contact.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports